export default {
  name: {
    id: 'rm_metal_iron_name',
    defaultMessage: 'Iron',
  },
  smartphoneLabel: {
    id: 'rm_metal_iron_smartphone_label',
    defaultMessage: 'Major',
  },
  whatItDoesText: {
    id: 'rm_metal_iron_what_it_does',
    defaultMessage:
      'Iron is the main ingredient in steel, providing strength and rigidity. In smartphones, it may be used in stainless-steel frames, screws, brackets and other structural parts, depending on the model.',
  },
  extractionText1: {
    id: 'rm_metal_iron_extraction_p1',
    defaultMessage:
      'Iron is mined mainly from hematite and magnetite ores, usually through large open-pit operations. The ore is crushed, screened, ground and concentrated, then formed into sinter or pellets. In a blast furnace, iron oxides are reduced with coke and limestone to produce pig iron, which is converted into steel. Electric arc furnaces can instead melt recycled steel scrap, using up to 100% scrap feedstock.',
  },
  quickFactText: {
    id: 'rm_metal_iron_quick_fact',
    defaultMessage:
      'Iron is abundant and essential to steel, but its huge production scale generates major mining waste and climate impacts. Recycling reduces these impacts, but cannot yet replace primary ore entirely.',
  },
  envSummaryText: {
    id: 'rm_metal_iron_env_summary',
    defaultMessage:
      'Iron ore mining is one of the world’s largest extractive activities. It moves huge volumes of rock and tailings, consumes water and energy, and can degrade air, water and habitats. The global steel industry accounts for approximately 7% of global energy consumption and up to 9% of global greenhouse-gas emissions. Steelmaking adds significant emissions, particularly when coal is used in blast furnaces.',
  },
  envWaterText: {
    id: 'rm_metal_iron_env_water_text',
    defaultMessage:
      'Iron ore mining can consume large amounts of water. Surface runoff and leachate from overburden and tailings can degrade water quality, while processing and steelmaking generate polluted wastewater.',
  },
  envSoilText: {
    id: 'rm_metal_iron_env_soil_text',
    defaultMessage:
      'Open-pit mining removes vegetation and topsoil and generates large volumes of overburden and tailings. Runoff and leachate from these materials can degrade soils and nearby water bodies.',
  },
  envBiodiversityText: {
    id: 'rm_metal_iron_env_biodiversity_text',
    defaultMessage:
      'Mining can clear vegetation, fragment habitats and alter landscapes. Runoff, tailings and water pollution can further affect aquatic and terrestrial ecosystems.',
  },
  envClimateText: {
    id: 'rm_metal_iron_env_climate_text',
    defaultMessage:
      'The global steel industry accounts for approximately 7% of global energy consumption and 7% to 9% of greenhouse-gas emissions. A life-cycle assessment estimated average emissions from iron ore mining and processing in China at around 270 kg CO2e per tonne of iron ore.',
  },
  humanSummaryText: {
    id: 'rm_metal_iron_human_summary',
    defaultMessage:
      'Iron mining and steelmaking can expose workers and nearby communities to dust, noise, accidents, heavy machinery, and air and water pollution. The sources provide limited iron-specific evidence on long-term health and social outcomes.',
  },
  humanHealthText: {
    id: 'rm_metal_iron_human_health_text',
    defaultMessage:
      'Under EU chemical regulations, iron ore is not classified as hazardous. However, mining and steelmaking can still expose workers and nearby communities to dust, noise, accidents and industrial pollution. The sources provide no iron-specific assessment of long-term health effects.',
  },
  geoSummaryText: {
    id: 'rm_metal_iron_geo_summary',
    defaultMessage:
      'Iron ore and steel are strategically important because steel underpins construction, transport, machinery, energy infrastructure and household appliances. The data show strong concentration at both stages: Australia and Brazil dominate usable iron ore production, while China leads the downstream processing of iron ore and the production of pig iron and steel.',
  },
  geoDugText: {
    id: 'rm_metal_iron_geo_dug_text',
    defaultMessage:
      'In 2024, Australia accounted for approximately 37.2% of global usable iron ore production, followed by Brazil at 17.6%, China and India at 10.8% each. These figures are based on a global total of approximately 2.5 billion tonnes of usable ore, not iron content. Australia, Brazil, China and India together accounted for approximately 76.4% of global production.',
  },
  geoProcessedText: {
    id: 'rm_metal_iron_geo_processed_text',
    defaultMessage:
      'In 2024, China accounted for approximately 64.6% of global pig iron production, the crude iron made by smelting iron ore. It also produced around 52.1% of global raw steel, made by refining pig iron or melting recycled scrap. India accounted for 7.2% of pig iron and 7.9% of raw steel production, while Japan accounted for 4.8% and 4.5%, respectively.',
  },
  geoLeverageText: {
    id: 'rm_metal_iron_geo_leverage_text',
    defaultMessage:
      'Australia and Brazil dominate iron ore exports, while China is the largest importer and steel producer. China’s dominant position in steelmaking means that changes in its demand can strongly affect iron ore prices and availability. Export taxes, licensing requirements, supply disruptions and transport constraints can further affect international markets.',
  },
  supplySummaryText: {
    id: 'rm_metal_iron_supply_summary',
    defaultMessage:
      'Although global iron resources and reserves are large, iron ore supply is concentrated among a few major producing countries, and the European Union relies heavily on imports at the extraction stage. Iron supply therefore remains exposed to demand growth and disruptions. Mine production is expected to increase from approximately 2.5 billion tonnes in 2024 to around 3 billion tonnes in 2030, after which it is expected to plateau. Recycling and low-carbon steelmaking could reduce pressure on primary ore, but will not eliminate the need for it.',
  },
  supplyReservesText: {
    id: 'rm_metal_iron_supply_reserves_text',
    defaultMessage:
      'Global iron ore reserves are estimated at approximately 200 billion tonnes of ore, containing around 88 billion tonnes of iron. The largest reserves are in Australia, Brazil and Russia. These figures refer to geological reserves of iron ore, not directly available reserves of refined iron metal.',
  },
  supplyDemandText: {
    id: 'rm_metal_iron_supply_demand_text',
    defaultMessage:
      'About 98% of the iron ore shipped worldwide is used to produce iron and steel. Steel demand is expected to grow with population and economic activity, with global steel production projected to rise from around 1.89 billion tonnes in 2023 to approximately 2.27 billion tonnes by 2050. Meanwhile, scrap-based production and electric arc furnaces are expected to expand, reducing the share of steel made from primary iron ore.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_iron_recycling_summary',
    defaultMessage:
      'Steel is one of the world’s most recycled materials and can be recycled repeatedly without losing its main properties. The estimated end-of-life functional recycling rate for iron and steel is approximately 70% to 90%. Recycling rates are lower for complex products such as electronic equipment and smartphones.',
  },
  recyclingInputText: {
    id: 'rm_metal_iron_recycling_input_text',
    defaultMessage:
      'A recent estimate places the European Union’s end-of-life recycling input rate for iron at approximately 46%. In 2023, around 45% of EU crude steel was produced through electric arc furnaces, which can use up to 100% recycled steel scrap. These figures concern iron and steel flows, not smartphones specifically.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_iron_recycling_outlook_text',
    defaultMessage:
      'Not on its own. Steel scrap can reduce CO2 emissions by approximately 58% and energy use by around 72% compared with primary production. However, steel used in buildings and infrastructure can remain in service for more than 60 years, limiting the availability of scrap. Even full recycling would not provide enough material to meet projected demand, so primary iron ore production will remain necessary. For smartphones, the quantities are too small and too mixed with other materials to be recovered specifically.',
  },
  footnote1Text1: {
    id: 'rm_metal_iron_footnote_1_p1',
    defaultMessage:
      'As iron is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
} as const
